import Head from 'next/head'
import AuthForm from '../components/authForm'

const Signin = () => {
  return (
    <>
      <Head>
        <title>singin</title>
        <link rel="icon" href="/logo.svg" />
      </Head>
      <AuthForm mode="signin" />
    </>
  )
}

Signin.authPage = true

export default Signin
